import { useState, useEffect } from "react";

let cachedTripTypes = null, cachedTripStatuses = null; // global in-memory cache

export const useTripTypes = ({ reload = false } = {}) => {
  const [tripTypes, setTripTypes] = useState(cachedTripTypes || []);
  const [loading, setLoading] = useState(false);

  const fetchTripTypes = async () => {
    setLoading(true);
    setTripTypes([
        { "idx": 1, "id": "air_import", "value": "Air Import" },
        { "idx": 2, "id": "air_export", "value": "Air Export" },
        { "idx": 3, "id": "ocean_import", "value": "Ocean Import" },
        { "idx": 4, "id": "ocean_export", "value": "Ocean Export" },
        { "idx": 5, "id": "fnd", "value": "F&D" },
        { "idx": 6, "id": "others", "value": "Others" }
    ]);
    setLoading(false);
  };

  useEffect(() => {
    if (!cachedTripTypes || reload) {
      fetchTripTypes();
    } else {
      setTripTypes(cachedTripTypes);
    }
  }, [reload]);

  return { tripTypes, loading, refresh: fetchTripTypes };
};

export const useTripStatuses = ({ reload = false } = {}) => {
  const [tripStatuses, setTripStatuses] = useState(cachedTripStatuses || []);
  const [loading, setLoading] = useState(false);

  const fetchTripStatuses = async () => {
    setLoading(true);
    setTripStatuses([
        { "id": "created", "value": "Created" },
        { "id": "ongoing", "value": "Ongoing" },
        { "id": "completed", "value": "Completed" },
        { "id": "cancelled", "value": "Cancelled" },
    ]);
    setLoading(false);
  };

  useEffect(() => {
    if (!cachedTripStatuses || reload) {
      fetchTripStatuses();
    } else {
      setTripStatuses(cachedTripStatuses);
    }
  }, [reload]);

  return { tripStatuses, loading, refresh: fetchTripStatuses };
};
